<template>
  <div class="sidebar" v-show="route.name !== 'index'">
  <!-- <div class="sidebar"> -->
    <el-scrollbar>
      <el-menu
        background-color="rgba(255,255,255,1)"
        text-color="rgba(51,51,51,1)"
        mode="vertical"
        :default-active="path"
        router
        :unique-opened="true"
      >
        <sidebar-item
          :item="route"
          :base-path="route.path"
          :is-collapse="false"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import SidebarItem from './SidebarItem.vue'
export default {
  name: 'SideBar',
  components: {
    SidebarItem
  },
  props: {
    tabIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      route: ''
    }
  },
  computed: {
    path () {
      return this.$route.path
    }
  },
  watch: {
    tabIndex: {
      handler (val) {
        this.route = this.$store.getters.routes.filter(item => {
          return item.meta && !item.meta.hidden
        })[val]
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .sidebar {
    position: fixed;
    left:120px;
    width:180px;
    height:100vh;
    padding-top:50px;
    overflow-y:hidden;
    margin-right:10px;
    border:1px solid #eee;
    background:#fff;
  }
  .el-menu {
    border:none
  }
  .el-scrollbar {
    height:100vh;
    box-shadow:1px 0px 0px 0px rgba(234,234,234,1);
    background:#fff;
  }
</style>
<style>
  .el-scrollbar__wrap {
    overflow: auto!important
  }
</style>
